import OfflineQueue from './queue/OfflineQueue';
import inventoryService from '../services/inventoryService';
import DAO from './DAO.js';
import StoreItemProcessing from '../helpers/StoreFunctions/StoreItemProcessing';

export default class InventoryDAO extends DAO {

  constructor(store) {
    super(store, 'inventory');
    this.OfflineQueue = OfflineQueue;

    this.unsetInventory = this.unsetInventory.bind(this);
    this.clearInventories = this.clearInventories.bind(this);
  }

  unsetInventory(id) {
    StoreItemProcessing.deleteItemInStore(this.itemType, id);
  }

  clearInventories() {
    StoreItemProcessing.clearItemsInStore(this.itemType);
  }

  getInventory(inventoryId, options) {
    return this._getItem(inventoryId, inventoryService.getInventory.bind(this, inventoryId), options);
  }

  clearState(options) {
    this.clearMyState(this.stateTree.new_inventories, options.toIgnore.inventories, this.unsetInventory, this.clearInventories, options);
  }
}



// WEBPACK FOOTER //
// ./src/dao/InventoryDAO.js